import { SelectedPurse } from '@/storage/applications/providerPaySlice'

export function getTotalAllocated(selectedPurses: SelectedPurse[]) {
  let current = 0

  selectedPurses.forEach((purse) => {
    current += Number(purse.amount)
  })

  return parseFloat(current.toFixed(2))
}

export function roundToTwoDecimals(value: number) {
  return parseFloat(value.toFixed(2))
}

export function calculateWithServiceFee(
  baseAmount: number,
  feePercentage: number
) {
  // Convert to cents to avoid floating point issues
  const baseAmountCents = Math.round(baseAmount * 100)

  const feeAmountCents = Math.round(baseAmountCents * (feePercentage / 100))

  // Calculate total in cents
  const totalAmountCents = baseAmountCents + feeAmountCents

  // might look a bit stupid to calculate this right now.
  // But I think this will be beneficial in the future when the rules for service fee changes.
  const totalMinusServiceFeeCents = totalAmountCents - feeAmountCents

  // Convert back to dollars for display
  return {
    baseAmount: baseAmount,
    feePercentage: feePercentage,
    feeAmount: feeAmountCents / 100,
    totalAmount: totalAmountCents / 100,
    // Also return the cent values for backend processing
    baseAmountCents: baseAmountCents,

    feeAmountCents: feeAmountCents,
    totalAmountCents: totalAmountCents,
    totalMinusServiceFeeCents: totalMinusServiceFeeCents,
    totalMinusServiceFee: totalMinusServiceFeeCents / 100,
  }
}
